<template>
  <tr>
    <td>
      <div class="acciones">
        <!-- Botón importar -->
        <button
          v-if="!UsaCodigoUnico"
          type="button"
          class="btn btn-primary"
          @click="clickImportar()"
        >
          <blaise-icon icon="IMPORTAR" />
        </button>
        <!-- Botón exportar -->
        <button
          v-if="!UsaCodigoUnico"  
          type="button"
          class="btn btn-success"
          @click="clickExportar()"
        >
          <blaise-icon icon="DESCARGAR" />
        </button>
        <!-- Botón detalle -->
        <button
          type="button"
          class="btn btn-secondary"
          @click="clickDetalle()"
        >
          <blaise-icon icon="INFO" />
        </button>
      </div>
    </td>
    <th scope="row">{{ valor.comercio.nombre }}</th>
    <td>{{ valor.comercio.localizacion }}</td>
    <td>{{ valor.nombre }}</td>
    <td>{{ valor.descuento }}</td>
    <td>{{ valor.diasHabilitados }}</td>
    <td>{{ valor.medioDePago }}</td>
  </tr>
</template>
<script>

export default {
  components: {
  },
  props: {
    valor: Object,
  },
  computed: {
    // Verificar que tipo de codigo usa. Si usa unico, deshabilitar botones import y export
    UsaCodigoUnico() {
      return this.valor.tipoCodigo == "UNICO";
    }
  },
  methods: {
    // TODO: IMPLEMENTAR METODOS
    clickImportar() {
      this.$emit("importar");
    },
    clickExportar() {
      this.$emit("exportar");
    },
    clickDetalle() {
      this.$emit("detalle");
    },
    
  },
};
</script>
<style lang="scss" scoped>
</style>